<template>
  <div>
    <div class="text-center text-[2rem] mb-4 font-bold">
      Request a <span class="text-orange-500"> demo</span> <br />
      to see how HeroGrow can help you
    </div>
    <transition name="fade">
      <div
        v-if="submitted"
        class="text-center text-[2rem] mb-4 font-bold border rounded-lg h-[600px] flex justify-center items-center"
      >
        Thank you for your&nbsp;<span class="text-orange-500">submission</span>!
        We'll be in touch soon.
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="!submitted"
        class="bg-white text-black p-4 max-w-[600px] mx-auto rounded-lg border-spacing-2 border-8 border-slate-400"
      >
        <form @submit.prevent="handleSubmit" class="space-y-4">
          <div class="flex flex-col">
            <label for="fullName" class="mb-2 font-semibold">Full Name*</label>
            <input
              type="text"
              id="fullName"
              v-model="formData.fullName"
              required
              class="p-2 border border-gray-300 rounded bg-gray-300"
            />
          </div>
          <div class="flex flex-col">
            <label for="email" class="mb-2 font-semibold">Email*</label>
            <input
              type="email"
              id="email"
              v-model="formData.email"
              required
              class="p-2 border border-gray-300 rounded bg-gray-300"
            />
          </div>
          <div class="flex flex-col">
            <label for="phone" class="mb-2 font-semibold">Phone Number*</label>
            <input
              type="tel"
              id="phone"
              v-model="formData.phone"
              required
              class="p-2 border border-gray-300 rounded bg-gray-300"
            />
          </div>
          <div class="flex flex-col">
            <label for="website" class="mb-2 font-semibold">Website URL*</label>
            <input
              type="text"
              id="website"
              v-model="formData.website"
              required
              class="p-2 border border-gray-300 rounded bg-gray-300"
            />
          </div>
          <div class="flex justify-center">
            <button
              type="submit"
              class="bg-orange-500 text-white text-xl font-bold px-4 py-2 rounded hover:bg-orange-600 mx-auto transition duration-300"
            >
              Show Me!
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>
<script setup>
import { ref } from "vue";
import api from "@/composables/api";

const formData = ref({
  fullName: "",
  email: "",
  phone: "",
  website: "",
});

const submitted = ref(false);

const handleSubmit = () => {
  api("v1/user/form/", {
    method: "POST",
    body: formData.value,
  })
    .then((res) => {
      // Handle the response
      // console.log("Form submitted:", res);
      submitted.value = true;
    })
    .catch((error) => {
      // Handle any errors
      console.error("Submission error:", error);
    });
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
